var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFaqBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8069 6.29688H12.1877L4.37814 19.8187L12.1877 33.3459H27.8069L35.6165 19.8187L27.8069 6.29688Z",
    fill: "#04ADAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99864 2.5H29.9959L40 19.8186L29.996 37.1425H9.99858L0 19.8186L9.99864 2.5ZM10.7197 3.7489L1.44204 19.8187L10.7198 35.8936H29.275L38.5578 19.8187L29.275 3.7489H10.7197Z",
    fill: "#00B7B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0918 12.7258H15.9028L11.8083 19.8187L15.9028 26.9117H24.0918L28.1863 19.8187L24.0918 12.7258Z",
    fill: "#57C4C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqBullet);
export default __webpack_public_path__ + "static/media/iconFaqBullet.3cce244e2b2f2c1a08957945c7f3091d.svg";
export { ForwardRef as ReactComponent };